export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
  BONUS_VALUE_ON_DEPOSIT = 'abtest_show_bonus_value_on_deposit',
  SEPARATED_WAGERING = 'abtest_separated_balance_plus_wagering',
  HIDE_SEARCH_ON_LOBBY = 'abtest_lu_hide_search_on_lobby',
  REMOVE_RECEIVE_BONUS = 'abtest_lu_remove_receive_bonus',
}

export const DATE_FORMAT = "yyyy-MM-dd HH:mm:ss 'UTC'";

export const AB_TESTS_START_DATE: Partial<Record<AB_TESTS, string>> = {
  [AB_TESTS.EXAMPLE]: '2026-01-01 00:00:00 UTC',
};
